import { createStyles, Popper, WithStyles, withStyles } from '@material-ui/core'
import { PopperProps } from '@material-ui/core/Popper'
import React, { useState } from 'react'
import arrowGenerator from '../../../../utils/arrowGenerator'
import { IWithSize } from '../../../../containers/BookingCalendar/Calendar/Calendar'
import HintWrapper from './HintWrapper'

const styles = ({ size }) =>
  createStyles({
    arrow: {
      '&::before': {
        borderStyle: 'solid',
        content: '""',
        display: 'block',
        height: 0,
        margin: 'auto',
        width: 0,
      },
      fontSize: 6,
      height: `${3 * size}em`,
      position: 'absolute',
      width: `${3 * size}em`,
    },
    popper: arrowGenerator('#fff'),
  })

const HintPopper: React.FunctionComponent<PopperProps &
  WithStyles &
  IWithSize & { width?: number } & { zIndex?: number }> = ({
                                                             children,
                                                             width,
                                                             classes,
                                                             zIndex = 49,
                                                             size = 1,
                                                             keepMounted,
                                                             open,
                                                             ...rest
                                                           }) => {
  const [arrowRef, setArrowRef] = useState(null)

  return (
    <Popper
      placement={'right'}
      {...rest}
      className={classes.popper}
      modifiers={{
        arrow: {
          element: arrowRef,
          enabled: true,
        },
        flip: {
          enabled: true,
        },
        preventOverflow: {
          boundariesElement: 'viewport',
          enabled: true,
        },
      }}
      open={open}
      keepMounted={keepMounted}
      style={{
        display: !keepMounted || open ? 'block' : 'none', //To prevent scroll event from firing
        zIndex: zIndex,
      }}
    >
      <>
        <div ref={setArrowRef} className={classes.arrow}/>
        <HintWrapper width={width} size={size}>
          {children}
        </HintWrapper>
      </>
    </Popper>
  )
}

export default withStyles(styles as any)(HintPopper)
